export class BasketSettings {
    constructor(basketSettings = {}) {
        const { storage, maxNumberOfProducts, basketKey, campaignKey, } = basketSettings;
        this._storage = storage !== null && storage !== void 0 ? storage : window.sessionStorage;
        this._maxNumberOfProducts = maxNumberOfProducts !== null && maxNumberOfProducts !== void 0 ? maxNumberOfProducts : 4;
        this._basketKey = basketKey !== null && basketKey !== void 0 ? basketKey : 'basket';
        this._campaignKey = campaignKey !== null && campaignKey !== void 0 ? campaignKey : 'campaign';
    }
    getSetting() {
        return {
            storage: this._storage,
            maxNumberOfProducts: this._maxNumberOfProducts,
            basketKey: this._basketKey,
            campaignKey: this._campaignKey,
        };
    }
    set storage(storage) {
        this._storage = storage;
    }
    set maxNumberOfProducts(maxNumberOfProducts) {
        this._maxNumberOfProducts = maxNumberOfProducts;
    }
    set basketKey(basketKey) {
        this._basketKey = basketKey;
    }
    set campaignKey(campaignKey) {
        this._campaignKey = campaignKey;
    }
}
